import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import useStyles from "../../styles";
import CobeeTextField from "../../../../../CobeeTextField";

export default function RowNumberQuotas({
  numberOfQuotas,
  setNumberOfQuotas,
}: {
  numberOfQuotas: string | number;
  setNumberOfQuotas(e: any): void;
}): JSX.Element {
  const { secondColumn } = useStyles();
  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("common-messages.number-of-quotas")}:
        </Typography>
      </Grid>
      <Grid item xs={6} className={secondColumn}>
        <Grid item xs={4}>
          <CobeeTextField
            styleType="default"
            variant="outlined"
            type="number"
            step="1"
            min={0}
            max={999}
            minWidth="100%"
            value={numberOfQuotas}
            onChange={(e) => setNumberOfQuotas(e.target.value)}
          />
        </Grid>
      </Grid>
    </>
  );
}
